import {
  id,
  init,
  InstantRules,
  InstaQLEntity,
  InstaQLParams,
  InstaQLResult,
  LinkParams,
  lookup,
  UpdateParams,
} from "@instantdb/react";
import schema from "./instant.schema";

const APP_ID = "8d0b3cc9-b04a-4a54-9e7a-967882e2bd0d";

const db = init({appId: APP_ID, schema, devtool: false});

export {db, id, lookup};
export type {
  InstantRules,
  InstaQLEntity,
  InstaQLParams,
  InstaQLResult,
  LinkParams,
  UpdateParams,
};
